;( function( $ ) {

    $( function() {

        $( '.hg-instructions-trigger' ).on( 'click', function( e ) {
            e.preventDefault();
            var $this = $( this );

            if ( ! $this.hasClass( 'open' ) ) {
                $( 'body, html' ).animate({ 'scrollTop': $this.offset().top - 50 }, 500 );
            }
            $this.toggleClass( 'open' );

            $( '#hg-instruction-text' ).slideToggle();
        });

    });

}( jQuery ));
